module.exports = __webpack_public_path__ + "static/img/dcBanner@2x.ae4ec21e.png";